import { Container } from "@mui/system";
import { Grid, Typography, Button } from '@mui/material';
import React from "react";
import globals from "../globals";

const RequestForMeetingAccept = () => {
    return (
        <Container>
            <Grid container justifyContent={'center'} textAlign={'center'} alignItems={'center'} direction={'column'}>
                <Grid item>
                    <Typography sx={{ color: globals.colors.lightRed, fontSize: 25, fontWeight: 'bold' }}>Заявката ти е изпратена!</Typography>
                </Grid>
                <Grid item>
                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold', mt: 4, mb: 4 }}>Очаквай имейл с потвърждение и повече информация.</Typography>
                </Grid>
                <Grid item>
                    <img src='request_accept.webp' width={300} height={270} />
                </Grid>
                <Grid item>
                    <Button variant='contained' href='/courses' type='submit' size='large' sx={{
                        mt: 3, mb: 3, px: 5, backgroundColor: globals.colors.lightRed, '&:hover': {
                            backgroundColor: globals.colors.darkRed,
                        }, textTransform: 'none', fontWeight: 'bold'
                    }}> Към курсове</Button>
                </Grid>
            </Grid>
        </Container>
    );
}

export default RequestForMeetingAccept